import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { mapGraphProductToListingProduct } from '../mappers/map-graph-product-to-listing-product.js';
import '../operations/queries/get-products-by-skus.js';
import { GET_PRODUCTS_BY_SKUS_EXTENDED } from '../operations/queries/get-products-by-skus-extended.js';

const useGetProductsBySkusExtended = ({ skus , priceSegment  })=>{
    var ref;
    const intl = useIntl();
    const result = useQuery(GET_PRODUCTS_BY_SKUS_EXTENDED, {
        variables: {
            skus
        },
        context: {
            headers: {
                'Accept-Language': intl.locale
            }
        }
    });
    if (result.loading) {
        return {
            isLoading: result.loading
        };
    }
    if (result.error) {
        return {
            error: result.error
        };
    }
    return {
        listingProducts: result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.getProductsBySKUs.map((prod)=>mapGraphProductToListingProduct(prod, intl, priceSegment)
        ).filter(isDefined).sort((a, b)=>skus.indexOf(a.masterVariant.sku) - skus.indexOf(b.masterVariant.sku)
        )
    };
};

export { useGetProductsBySkusExtended };
//# sourceMappingURL=use-get-products-by-skus-extended.js.map
